import CancelDayOffUser from 'features/cancelDayOff/cancelDayOffUser';
import { useTitle } from '../helpers';

/**
 * @page CancelDayOffUserPage
 */

const CancelDayOffUserPage = () => {
  useTitle('Отмена отгула');
  return <CancelDayOffUser />;
};

export default CancelDayOffUserPage;
